module.exports = __webpack_public_path__ + "img/vertical_6_6_9006.ded1fcaa.png";